<!-- Container-fluid starts-->
<div class="container-fluid">
  <!-- parameter cards -->
  <div class="row">

    <div class="col-lg-2 col-md-2 col-6">
      <div class="card o-hidden">
        <div class="b-r-4 card-body inniver-bg-visitor-color">
          <div class="media static-top-widget text-white">
            <div class="media-body"><span class="m-0">Visitors</span>
              <h4 class="mt-0 mb-0 f-w-900"><span>{{klocki.visitors}}</span></h4>
              <i class="icon-bg" data-feather="eye"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-2 col-md-2 col-6">
      <div class="card o-hidden">
        <div class="b-r-4 card-body inniver-bg-click-color">
          <div class="media static-top-widget text-white">
            <div class="media-body"><span class="m-0">Clicks</span>
              <h4 class="mt-0 mb-0 f-w-900"><span>{{klocki.clicks}}</span></h4>
              <i class="icon-bg" data-feather="arrow-down"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-2 col-md-2 col-6">
      <div class="card o-hidden">
        <div class="b-r-4 card-body inniver-bg-conversion-color">
          <div class="media static-top-widget text-white">
            <div class="media-body"><span class="m-0">Conversions</span>
              <h4 class="mt-0 mb-0 f-w-900"><span>{{klocki.conversions}}</span></h4>
              <i class="icon-bg" data-feather="refresh-cw"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-2 col-md-2 col-6">
      <div class="card o-hidden">
        <div class="b-r-4 card-body inniver-bg-revenue-color">
          <div class="media static-top-widget text-white">
            <div class="media-body"><span class="m-0">Revenue</span>
              <h4 class="mt-0 mb-0 f-w-900"><span>${{klocki.revenue | number: '1.2-2'}}</span></h4>
              <i class="icon-bg" data-feather="dollar-sign"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-2 col-md-2 col-6">
      <div class="card o-hidden">
        <div class="b-r-4 card-body inniver-bg-epc-color">
          <div class="media static-top-widget text-white">
            <div class="media-body"><span class="m-0">EPC</span>
              <h4 class="mt-0 mb-0 f-w-900"><span>{{klocki.epc | currency:'CAD':'symbol-narrow':'1.4-4'}}</span></h4>
              <i class="icon-bg" data-feather="pie-chart"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-2 col-md-2 col-6">
      <div class="card o-hidden">
        <div class="b-r-4 card-body inniver-bg-cr-color">
          <div class="media static-top-widget text-white">
            <div class="media-body"><span class="m-0">CR</span>
              <h4 class="mt-0 mb-0 f-w-900"><span>{{klocki.cr | percent}}</span></h4>
              <i class="icon-bg" data-feather="trending-up"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- pierwsza linia parametrów -->
  <div class="row">
    <div class="col-lg-6">      
      <table>
        <tr>          
          <!-- date range -->        
          <td style="width: 1px; white-space: nowrap;">           
            <label for="daterange">Date range:&nbsp;</label>  
            <select class="form-select newclass" [(ngModel)]='SelectedDaterange' id="daterange" (change)="changeDaterangeSelect($event)">
              <option value=1 >Today</option>
              <option value=2 >Yesterday</option>
              <option value=3 >Last 7 days</option>
              <option value=4 >Last 30 days</option>
              <option value=5 >MTD</option>
              <option value=6 >Last Month..</option>
            </select>&nbsp;
          </td>
          
          <td style="width: 1px; white-space: nowrap;" *ngIf="visible.datemonthVisible">              
            <label for="idDate12month">Last month:&nbsp;</label>
            <select class="form-select newclass" id="idDate12month" [(ngModel)]='SelectedDate12month' (change)="changeDate12month($event)">
              <option value="1" >January</option>
              <option value="2" >February</option>
              <option value="3" >March</option>
              <option value="4" >April</option>
              <option value="5" >May</option>
              <option value="6" >June</option>
              <option value="7" >July</option>
              <option value="8" >August</option>
              <option value="9" >September</option>
              <option value="10" >October</option>
              <option value="11" >November</option>
              <option value="12" >December</option>
            </select>&nbsp;
          </td>

          <!-- group BY -->
          <td style="width: 1px; white-space: nowrap;">
            <div *ngIf="visible.groupbyVisible == true">
              <label for="idgroupby">Group by:&nbsp;</label>
              <select class="form-select newclass" id="idgroupby" [(ngModel)]='SelectedGroupby' (change)="changeGroupbySelect($event)">
                <option value=1 >Offer</option>
                <option value=2 >Locker</option>
                <option value=3 >Country</option>
                <option value=4 >Browser</option>
                <option value=5 >OS</option>
                <option value=6 >Device</option>
              </select>&nbsp;
            </div>

            <!-- group BY dla -->
            <div *ngIf="visible.groupbyVisible == false">
              <label for="idgroupby">Group by:&nbsp;</label>
              <select class="form-select newclass" id="idgroupby" [(ngModel)]='SelectedGroupby' (change)="changeGroupbySelect($event)">
                <option value=2 selected>Locker</option>
                <option value=4 >Browser</option>
                <option value=5 >OS</option>
                <option value=6 >Device</option>
              </select>&nbsp;
            </div>
          </td>
          
          <td style="width: 200px; white-space: nowrap;" *ngIf="visible.groupbyoffercountryVisible">
            <label>Offer country:&nbsp;</label>
            <ng-multiselect-dropdown
              style="width: 200px; white-space: nowrap;"
              class="newclass"
              [placeholder]="'-- All --'"
              [settings]="dropdownSettingsOfferCountry"
              [data]="detailsOfferCountry"
              [(ngModel)]="dropdownSelectedOfferCountry"
              (onSelect)="ondropdownSelectOfferCountry($event)"
              (onDeSelect)="ondropdownDeSelectOfferCountry($event)"
            >
            </ng-multiselect-dropdown>
          </td>

          <!-- details zmienne -->
          <td col-lg-6 style="width: 200px; white-space: nowrap;" *ngIf="visible.itemsdetailVisible">
              <label>Details:&nbsp;</label>                
              <ng-multiselect-dropdown
                style="width: 200px;"
                class="newclass"
                [placeholder]="'-- All --'"
                [settings]="dropdownSettingsDetails"
                [data]="detailsData"
                [(ngModel)]="dropdownSelectedDetails"
                (onSelect)="ondropdownSelectDetails($event)"
                (onDeSelect)="ondropdownDeSelectDetails($event)"
              >
              </ng-multiselect-dropdown>&nbsp;                
          </td>

          <td style="width: 1px; white-space: nowrap;" *ngIf="visible.selectVisible">
              <label for="select">Select:&nbsp;</label>
              <select class="form-select newclass" id="select" [(ngModel)]='selectType' (change)="changeSelectType($event)">
                <option value=1 >Visitors</option>
                <option value=2 >Clicks</option>
                <option value=3 >Conversions</option>
                <option value=4 selected >Revenue</option>
              </select>&nbsp;
          </td>
          
          <!-- details zmienne -->
          <td class="h3" style="width: 1px; white-space: nowrap;">
            <i class="fa fa-table {{icoGridColor}} " ngbTooltip="table of data" (click)="onGridIco()" *ngIf="visible.icoGrid"></i>&nbsp;
            <i class="fa fa-globe {{icoGlobeColor}}" ngbTooltip="view world map" (click)="onGlobeIco()"></i>&nbsp;
            <i class="icofont icofont-pie-chart {{icoPieColor}}" ngbTooltip="group by for all-Top 10" (click)="onPieIco()"></i>
          </td>
        </tr>

      </table>
    </div>

  </div><p></p>

  <p></p>

  <!-- wykresy/tabele -->
  <div class="card">
    <div class="card-body">
  <div class="row ">
    <!-- Main window -->
    <div class="col-lg-12 col-md-12 col-12">

          <div class="row" *ngIf="activeView=='globe'">
            <div class="col-lg-12 col-md-12 col-12 txt-center" style="text-align: center;">
              <!-- <img alt="" src="../../../../../assets/images/testglob.PNG"> -->
              <div echarts [options]="optionWorld" class="demo-chart" *ngIf="isChartGlobe"></div>
              <div style="text-align: center;" *ngIf="isChartGlobe === false">
                <img src="../../../../../assets/images/nodatatodisplay.png" alt="nodata" >
              </div>              
            </div>
          </div>

          <div class="row" *ngIf="activeView=='pie'">
            <div class="col-lg-12 col-md-12 col-12 txt-center" style="text-align: center;">
              <!-- <img alt="" src="../../../../../assets/images/testpie.PNG"> -->
              <div echarts [options]="optionPie" class="demo-chart" *ngIf="isChartPie"></div>
              <div style="text-align: center;" *ngIf="isChartPie === false">
                <img src="../../../../../assets/images/nodatatodisplay.png" alt="nodata" >
              </div>
            </div>
          </div>

          <!-- chart -->
          <div class="row" *ngIf="activeView=='timeline'">
            <div class="col-lg-12 col-md-12 col-12">

              <div echarts [options]="option" class="demo-chart" *ngIf="isChartTimeline"></div>
              <div style="text-align: center;" *ngIf="isChartTimeline === false">
                <img src="../../../../../assets/images/nodatatodisplay.png" alt="nodata" >
              </div>
            </div>
          </div>

          <!-- table -->
          <div class="row" *ngIf="viewTable">
            <div class="col-lg-12 col-md-12 col-12">
              <div class="custom-datatable">
              <ngx-datatable
              class='bootstrap'
              [rows]="dataGrid"
              [columnMode]="ColumnMode.force"
              [headerHeight]="50"
              [footerHeight]="50"
              [rowHeight]="'auto'"
              [externalPaging]="true"
              [count]="page.totalElements"
              [offset]="page.pageNumber"
              [limit]="page.size"
              (page)="setPage($event)"
              [sorts]="[{prop: 'date', dir: 'desc'}]"
              >

              <ngx-datatable-column name="date" prop="date">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Date</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.date | date:'d/MM/yyyy'}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="groupByValue" >
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Group by</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.groupByValue}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="visitors">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Visitors</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.visitors}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Clicks">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Clicks</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.clicks}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="conversions">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Conversions</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.conversions}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="revenue">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Revenue</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.revenue | currency}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="epc">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">EPC</span>
                </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.epc | currency:'CAD':'symbol-narrow':'1.4-4'}}
              </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="cr">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">CR</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.cr | percent}}
                </ng-template>
              </ngx-datatable-column>

            </ngx-datatable>
          </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
